import React, { useState, useEffect } from "react";
// import TableViewSearch from "../TableViewSearch";
import TableView from "../TableView";
import useStyles from "../styles";
// import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
// // import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
// import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
// import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
// import DeleteIcon from "@material-ui/icons/Delete";
// import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
// import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
// import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
// import { ReactComponent as AddQuestionIcon } from "../../../images/examimage/addquestion.svg";
// import { ReactComponent as AddMarksIcon } from "../../../images/examimage/addmarks.svg";
// import { ReactComponent as DashboardIcon } from "../../../images/examimage/dashboard.svg";
// import { ReactComponent as ResultIcon } from "../../../images/examimage/result.svg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { decryptData } from "../../../crypto";
import { toast } from "react-toastify";
import {
  IconButton,
  Popover,
  Typography,
  Button,
  Grid,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  fetchTodayExam,
  fetchCurrentTimeApi,
  loginApi,
  instructionLogsApi,
  getLocalIP,
} from "../../../services/service";
import socket from "../../../socket/socket";
import Loader from "../../../components/Loader";
import InstructionPopup from "./InstructionPopup";
import ExamCard from "./ExamCard";
import NoDataFoundImage from "../../../images/noExam.png";
import ROUTES_NAME from "../../../constants/RoutesName";

function ViewExam() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [exam, setExam] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openInstructions, setOpenInstructions] = useState(false);
  const [examInstructions, setExamInstructions] = useState();
  const [examInstructionsHindi, setExamInstructionsHindi] = useState();
  const [examId, setExamId] = useState(null);
  const [currentTime, setCurrentTime] = useState(null);
  const navigate = useNavigate();
  const theme = useTheme();
  const [reloginData, setReloginData] = useState(null);
  const [reloginDataAll, setReloginDataAll] = useState(null);

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const handleOpenInstructions = () => {
    setOpenInstructions(true);
  };

  const handleCloseInstructions = () => {
    setOpenInstructions(false);
  };

  const handleClick = (event, rowId, date, time, exam_pin, exam_type, before_instruction) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
    handleNextClick(date, time, exam_pin, exam_type, before_instruction);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // const handleButtonClickQuestion = (type) => {
  //   navigate(`/admin/${type}`);
  // };

  // Function to delete a book

  // const LightTooltip = withStyles((theme) => ({
  //   tooltip: {
  //     backgroundColor: theme.palette.common.white,
  //     color: "rgba(0, 0, 0, 0.87)",
  //     boxShadow: theme.shadows[1],
  //     fontSize: 11,
  //   },
  // }))(Tooltip);

  const fetchTodayExamData = async () => {
    try {
      const candidateData = await fetchTodayExam();
      setExam(candidateData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const instructionLogs = (examId) => {
    const userId = sessionStorage.getItem("userId");

    getLocalIP(async (ip) => {
      if (ip) {
        const data = {
          exam_id: examId,
          user_id: userId,
          ip,
        };
        try {
          const response = await instructionLogsApi(data);
        } catch (error) {
          console.error("Error fetching data: ", error);
        }
      }
    });
  };

  useEffect(() => {
    if (exam.length === 0) {
      fetchTodayExamData();
    }
  }, []);

  function getBaseUrl() {
    const url = new URL(window.location.href);
    return `${url.protocol}//${url.host}/instructions`;
  }

  const startExam = (data) => {
    if (loading) {
      return;
    }

    setLoading(true);
    getLocalIP(async (ip) => {
      if (ip) {
        // try {
        //   const result = await loginApi({ ...data, ip });
        //   if (result.success) {
        //     setLoading(false);
        //     toast.success("Login Successful!");

        //     socket.emit("changeStatus", {
        //       examId: result.examId,
        //       userId: result.userId,
        //       status: "On instructions",
        //     });

        //     const width = window.screen.availWidth;
        //     const height = window.screen.availHeight;
        //  const popup  =  window.open(
        //       getBaseUrl(),
        //       "_blank",
        //       `toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=${width},height=${height},top=0,left=0`
        //     );

        //     const handleVisibilityChange = () => {
        //       if (popup) {
        //         console.log("🟡 Window minimized or user switched tab");
        //         popup.focus();
        //       } else {
        //         console.log("🟢 Window active again");
        //       }
        //     };

        //     document.addEventListener(
        //       "visibilitychange",
        //       handleVisibilityChange
        //     );

        //     setTimeout(() => {
        //       sessionStorage.clear();
        //       window.location.reload();
        //     }, 3000);
        //   } else {
        //     setLoading(false);
        //     toast.warning(result.message);
        //   }
        // } catch (err) {
        //   setLoading(false);
        //   console.log(err);
        // }
        try {
          const result = await loginApi({ ...data, ip });

          if (result.success) {
            setLoading(false);
            toast.success("Login Successful!");

            socket.emit("changeStatus", {
              examId: result.examId,
              userId: result.userId,
              status: "On instructions",
            });
            // navigate(ROUTES_NAME.INSTRUCTION);
            // sessionStorage.setItem("candidateLoggedinToInstructionsPage", true);

            if (isMobile) {
              // Mobile/Tablet: Redirect in the same tab and prevent back navigation
              sessionStorage.setItem(
                "candidateLoggedinToInstructionsPage",
                true,
              );
              navigate(ROUTES_NAME.INSTRUCTION, { replace: true });
            } else {
              // Desktop/Laptop: Open in a new tab
              const width = window.screen.availWidth;
              const height = window.screen.availHeight;

              const popup = window.open(
                getBaseUrl(),
                "_blank",
                `toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=${width},height=${height},top=0,left=0`,
              );

              // Detect when MAIN window is hidden or loses focus
              const handleVisibilityChange = () => {
                if (document.hidden) {
                  if (popup && !popup.closed) {
                    popup.focus(); // bring popup on top
                  }
                }
              };

              const handleBlur = () => {
                if (popup && !popup.closed) {
                  popup.focus();
                }
              };

              const handleFocus = () => {};

              document.addEventListener(
                "visibilitychange",
                handleVisibilityChange,
              );
              window.addEventListener("blur", handleBlur);
              window.addEventListener("focus", handleFocus);

              // Optional cleanup when popup closes
              const interval = setInterval(() => {
                if (!popup || popup.closed) {
                  document.removeEventListener(
                    "visibilitychange",
                    handleVisibilityChange,
                  );
                  window.removeEventListener("blur", handleBlur);
                  window.removeEventListener("focus", handleFocus);
                  clearInterval(interval);
                }
              }, 1000);

              // Logout from dashboard smoothly for desktop
              setTimeout(() => {
                sessionStorage.clear();
                window.location.reload();
                // navigate(ROUTES_NAME.LOGIN, { replace: true });
              }, 1500);
            }
          } else {
            setLoading(false);
            toast.warning(result.message);
          }
        } catch (err) {
          setLoading(false);
          console.log(err);
        }
      }
    });
  };

  const fetchCurrentTime = async () => {
    try {
      const response = await fetchCurrentTimeApi();
      if (response.data.success) {
        const cTime = new Date(response.data.currentTime);
        setCurrentTime(cTime);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchCurrentTime();

    const interval = setInterval(fetchCurrentTime, 60000);
    return () => clearInterval(interval);
  }, []);

 const handleReLogin = (data) => {
  setReloginData(data);
};

 const handleReLoginAll = (data) => {
  setReloginDataAll(data);
};

useEffect(() => {
  if (!reloginData || exam.length === 0) return;

  const { examId, userId } = reloginData;

  const isSameUser = userId === sessionStorage.getItem("userId");

  const examExists = exam.some(
    (e) => Number(e.id) === Number(examId)
  );

  if (isSameUser && examExists) {
    toast.success("You can start the exam");
  }
}, [reloginData, exam]);

useEffect(() => {
  if (!reloginDataAll || exam.length === 0) return;

  const { examId } = reloginDataAll;

  const examExists = exam.some(
    (e) => Number(e.id) === Number(examId)
  );

  if (examExists) {
    toast.success("You can start the exam");
  }
}, [reloginDataAll, exam]);

useEffect(() => {
  if (!currentTime || exam.length === 0) return;

  exam.forEach((examData) => {
    const startDateTime = new Date(
      `${examData.start_date}T${examData.start_time}`
    );

    const isSameMinute =
      currentTime.getFullYear() === startDateTime.getFullYear() &&
      currentTime.getMonth() === startDateTime.getMonth() &&
      currentTime.getDate() === startDateTime.getDate() &&
      currentTime.getHours() === startDateTime.getHours() &&
      currentTime.getMinutes() === startDateTime.getMinutes();

    if (isSameMinute) {
      toast.success(`You can start the exam: ${examData.name || ""}`);
    }
  });

}, [currentTime, exam]);

  useEffect(() => {
    socket.connect();
    socket.on("re_login", handleReLogin);
    socket.on("re_login_all", handleReLoginAll);
    return () => {
      socket.off("re_login", handleReLogin);
      socket.off("re_login_all", handleReLoginAll);
      socket.disconnect();
    };
  }, []);

  const handleNextClick = async (date, time, exam_pin, exam_type, before_instruction) => {
    // Block main exam if an unsubmitted demo exam exists in the list
    if (exam_type === "main") {
      const hasUnsubmittedDemo = exam.some(
        (e) => e.exam_type === "demo" && e.status !== "submitted",
      );
      if (hasUnsubmittedDemo) {
        toast.warning("Submit your feedback exam first");
        return;
      }
    }
    try {
      setLoading(true);
      const response = await fetchCurrentTimeApi();
      const currentTime = new Date(response.data.currentTime);

      const [year, month, day] = date.split("-").map(Number);
      const [hours, minutes, seconds] = time.split(":").map(Number);

      const startDateTime = new Date(
        year,
        month - 1,
        day,
        hours,
        minutes,
        seconds,
      );

      sessionStorage.setItem("startDateTime", startDateTime.toISOString());
      const isBeforeInstruction = before_instruction === "yes";

      if (currentTime.getTime() >= startDateTime.getTime() || isBeforeInstruction) {
        const userAuth = JSON.parse(sessionStorage.getItem("userAuth"));
        const data = { ...userAuth, exam_pin };
        startExam(data);
      } else {
        setLoading(false);
        toast.warning("You cannot start the exam before the scheduled time.");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error checking exam time:", error);
      toast.error("Failed to verify exam schedule. Please try again.");
    }
  };

  const handleInstructionsClick = (rowId) => {
    if (!Array.isArray(exam)) return;
    exam.forEach((data) => {
      if (Number(data.id) === Number(rowId)) {
        setExamId(data.id);
        if (
          data.exam_instruction_en !== "undefined" ||
          data.exam_instruction_en !== undefined
        ) {
          setExamInstructions(
            data.exam_instruction_en +
              (data.genral_instruction_en
                ? "<h3>Exam Instructions</h3>" + data.genral_instruction_en
                : ""),
          );
        }

        setExamInstructionsHindi(
          data.exam_instruction_hi +
            (data.genral_instruction_hi
              ? "<h3>Exam Instructions</h3>" + data.genral_instruction_hi
              : ""),
        );
      }
    });
    instructionLogs(rowId);
    handleOpenInstructions();
  };

  const rows = Array.isArray(exam)
    ? exam.map((d, index) => ({
      srno: index + 1,
      id: d.id ? d.id : "N/A",
      exam_name: d.exam_name ? d.exam_name : "N/A",
      start_date: d.start_date ? d.start_date : "N/A",
      duration: d.duration ? d.duration : "N/A",
      start_time: d.start_time ? d.start_time : "N/A",
      exam_pin: d.exam_pin ? d.exam_pin : null,
      end_time: d.end_time ? d.end_time : null,
      status: d.status ? d.status : null,
      exam_type: d.exam_type ? d.exam_type : null,
      before_instruction: d.before_instruction ? d.before_instruction : "no",
    }))
    : [];


  return (
    <>
      {loading && <Loader />}
      {/* <ToastContainer /> */}
      <Box
        sx={{
          background: "white",
          mt: 1,
          borderRadius: "6px",
          // boxShadow: 3,
          overflow: "hidden",
          width: "100%",
        }}
      >
        {/* <TableViewSearch Heading={Heading} onSearch={handleSearch} /> */}
        {/* <TableView columns={columns} rows={rows} Heading={style} /> */}
        {/* <Grid
          container
          spacing={2}
          // justifyContent="center"
          // alignItems="center"
          // sx={{ minHeight: "100vh" }} // centers vertically also
          padding={2}
        >
          <Grid item xs={12}>
            <ExamCard
              exam={{
                name: "Mathematics Exam",
                startDate: "15 Sept 2025",
                startTime: "10:00 AM",
                duration: "2 hours",
              }}
            />
          </Grid>
          
        </Grid>{" "} */}

        <Box
          sx={{
            padding: { xs: "10px", sm: "20px" },
          }}
        >
          {rows.length === 0 ? (
            <div>
              <img
                src={NoDataFoundImage}
                style={{
                  maxWidth: "100%",
                  maxHeight: "300px",
                  opacity: 0.5,
                  margin: "auto",
                  display: "block",
                }}
                alt=""
              />
            </div>
          ) : (
            rows.map((exam) => (
              <div key={exam.id}>
                <ExamCard
                  exam={exam}
                  handleClick={handleClick}
                  handleInstructionsClick={handleInstructionsClick}
                  currentTime={currentTime}
                />
              </div>
            ))
          )}
        </Box>

        <InstructionPopup
          openInstructions={openInstructions}
          handleCloseInstructions={handleCloseInstructions}
          examInstructions={examInstructions}
          examInstructionsHindi={examInstructionsHindi}
          examId={examId}
        />
      </Box>
    </>
  );
}
export default ViewExam;
